<template>
    <div class="select-exchange">
        <div class="select-exchange__content">
            <div class="select-exchange__top">
                <h3>Выберите счет</h3>
                <button @click="$store.commit('changeSelectExchange', false)">
                    <img src="@/assets/images/close-circle.svg" alt="">
                </button>
            </div>
            <div class="select-exchange__btn">
                <button @click="tab = 1" :class="{'active': tab == 1}">
                    <span>Из</span>
                    <span>RUB</span>
                </button>
                <button @click="tab = 2" :class="{'active': tab == 2}">
                    <span>В</span>
                    <span>USD</span>
                </button>
            </div>
            <div v-if="tab == 1" class="tab_item">
                <div class="search-assets__inp">
                    <button>
                        <img src="@/assets/images/search-icon.svg" alt="">
                    </button>
                    <input type="text" placeholder="Поиск">
                </div>
                <ul class="select-exchange__list">
                    <li v-for="(item, idx) in walletList" :key="idx" @click="selectFrom(item)">
                        <div>{{item.currency_code}}</div>
                        <span class="amount">{{getCurrencySymbol(item.currency_code)}} {{item.balance}}</span>
                    </li>
                </ul>
            </div>
            <div v-if="tab == 2" class="tab_item">
                <div class="search-assets__inp">
                    <button>
                        <img src="@/assets/images/search-icon.svg" alt="">
                    </button>
                    <input type="text" placeholder="Поиск">
                </div>
                <ul class="select-exchange__list">
                    <li v-for="(item, idx) in walletList" :key="idx">
                        <div>{{item.currency_code}}</div>
                        <span class="amount">{{getCurrencySymbol(item.currency_code)}} {{item.balance}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Select Exchange",
    computed: {
        walletList () {
            return this.$store.state.walletList
        }
    },    
    data () {
        return {
            tab: 1,
        }
    },
    methods: {
        selectFrom (account) {
            console.log(account)
        }
    }
}
</script>

<style>

</style>